import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, X, ArrowRight } from "lucide-react";
import { useCart } from "../hooks/useCart";
import { API } from "../config/constants";
import axios from "axios";

export default function CheckoutSuccessPage() {
  const [status, setStatus] = useState("checking");
  const { clearCart } = useCart();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    const pollStatus = async (attempts = 0) => {
      if (attempts >= 5) { setStatus("timeout"); return; }
      try {
        const response = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (response.data.payment_status === "paid") { setStatus("success"); clearCart(); }
        else if (response.data.status === "expired") { setStatus("expired"); }
        else { setTimeout(() => pollStatus(attempts + 1), 2000); }
      } catch (error) { console.error("Error checking status:", error); setStatus("error"); }
    };
    pollStatus();
  }, [clearCart]);

  return (
    <div data-testid="checkout-success-page" className="pt-20 min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="container-custom max-w-lg text-center">
        {status === "checking" && (
          <div className="bg-white p-12 rounded-xl shadow-lg">
            <div className="animate-spin w-16 h-16 border-4 border-[#D90429] border-t-transparent rounded-full mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-[#0F2137] mb-2">Processing Payment</h2>
            <p className="text-[#495057]">Please wait while we confirm your order...</p>
          </div>
        )}
        {status === "success" && (
          <div className="bg-white p-12 rounded-xl shadow-lg">
            <CheckCircle className="mx-auto text-green-500 mb-6" size={80} />
            <h2 className="text-3xl font-bold text-[#0F2137] mb-4">Payment Successful!</h2>
            <p className="text-[#495057] mb-8">Thank you for your purchase. You'll receive a confirmation email shortly.</p>
            <Link to="/merch" className="btn-primary inline-flex items-center gap-2">Continue Shopping <ArrowRight size={20} /></Link>
          </div>
        )}
        {(status === "error" || status === "timeout" || status === "expired") && (
          <div className="bg-white p-12 rounded-xl shadow-lg">
            <X className="mx-auto text-red-500 mb-6" size={80} />
            <h2 className="text-3xl font-bold text-[#0F2137] mb-4">{status === "expired" ? "Session Expired" : "Something Went Wrong"}</h2>
            <p className="text-[#495057] mb-8">{status === "expired" ? "Your checkout session has expired. Please try again." : "We couldn't verify your payment. Please contact support if you were charged."}</p>
            <Link to="/merch" className="btn-primary inline-flex items-center gap-2">Return to Store <ArrowRight size={20} /></Link>
          </div>
        )}
      </div>
    </div>
  );
}
